import { useState } from 'react';

const ROLES = [
  { value: 'owner', label: 'Team Owner' },
  { value: 'admin', label: 'Team Admin' },
  { value: 'user', label: 'LMS User' },
  { value: 'shop_owner', label: 'Shop Owner' },
  { value: 'shop_admin', label: 'Shop Admin' },
  { value: 'shop_user', label: 'Shop User' },
];

interface RoleFilterModalProps {
  selected: Set<string>;
  onApply: (roles: Set<string>) => void;
  onClose: () => void;
}

export function RoleFilterModal({ selected, onApply, onClose }: RoleFilterModalProps) {
  const [checked, setChecked] = useState<Set<string>>(new Set(selected));

  const toggle = (role: string) => {
    setChecked((prev) => {
      const next = new Set(prev);
      if (next.has(role)) next.delete(role);
      else next.add(role);
      return next;
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-sm mx-4">
        <div className="px-6 pt-6 pb-4">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Filter by Role</h2>
          <div className="space-y-3">
            {ROLES.map((r) => (
              <label key={r.value} className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={checked.has(r.value)}
                  onChange={() => toggle(r.value)}
                  className="rounded border-gray-300"
                />
                {r.label}
              </label>
            ))}
          </div>
        </div>
        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onApply(checked)}
            disabled={checked.size === 0}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
